import React from 'react';

const RequiredFieldIcon = () => {
  return (
    <div style={{ position: 'absolute', left: '-12px', top: '8px' }}>
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5625 3.99994L6.04688 2.51556L5.03125 1.5L4 3.03119L2.96875 1.5L1.95312 2.51556L3.4375 3.99994L1.95312 5.48431L2.96875 6.5L4 4.96875L5.03125 6.5L6.04688 5.48431L4.5625 3.99994Z"
          fill="#FF4D4F"
        />
      </svg>
    </div>
  );
};

export default RequiredFieldIcon; 